import { Component } from '@angular/core';
import { TabSyncService } from 'src/app/_services/tab-sync.service';

/**
 * Confirmation popup shown before a login, logout or school switch that will
 * reload / sign out the user's other open tabs. Rendered once in app.component.html
 * and driven by TabSyncService.confirm$.
 */
@Component({
  selector: 'app-tab-sync-dialog',
  templateUrl: './tab-sync-dialog.component.html',
  styleUrls: ['./tab-sync-dialog.component.scss']
})
export class TabSyncDialogComponent {
  confirm$ = this.tabSyncService.confirm$;

  constructor(private tabSyncService: TabSyncService) { }

  get isRtl(): boolean {
    return localStorage.getItem('lang') === 'ar';
  }
}
